import Hls from 'hls.js/dist/hls.light.min.js';
import Plyr from 'plyr/dist/plyr.polyfilled.js';
Plyr.setup('.plyr');
var Video = /** @class */ (function () {
    function Video(videoEls) {
        var _this = this;
        videoEls.forEach(function (video) {
            var srcHls = video.getAttribute('data-src-hls');
            var autoplay = video.getAttribute('data-autoplay') || video.getAttribute('data-autoplay') === '' ? true : false;
            if (Hls.isSupported() && srcHls) {
                var hlsVideo_1 = new Hls({
                    startLevel: 2,
                    minAutoBitrate: 1135000,
                    autoStartLoad: false,
                });
                hlsVideo_1.attachMedia(video);
                hlsVideo_1.loadSource(srcHls);
                hlsVideo_1.on(Hls.Events.MANIFEST_PARSED, function () {
                    if (autoplay) {
                        hlsVideo_1.startLoad();
                        _this.forceAutoPlay(video);
                    }
                });
                hlsVideo_1.on(Hls.Events.LEVEL_SWITCHING, function (event, data) {
                    var videoParentEl = video.parentElement;
                    if (videoParentEl) {
                        var playerWidth_1 = videoParentEl.clientWidth || document.documentElement.clientWidth;
                        var viableLevels = hlsVideo_1.levels.filter(function (level) { return level.width <= playerWidth_1; });
                        var maxViableLevel = Math.max(viableLevels.length, 2);
                        console.log("HLS: Request quality " + data.level + " (max: " + maxViableLevel + " / " + playerWidth_1 + "px)");
                        hlsVideo_1.autoLevelCapping = maxViableLevel;
                    }
                });
                hlsVideo_1.on(Hls.Events.LEVEL_SWITCHED, function (event, data) {
                    console.log("HLS: Changed quality to " + data.level);
                });
                hlsVideo_1.on(Hls.Events.ERROR, function (event, data) {
                    if (data.fatal) {
                        switch (data.type) {
                            case Hls.ErrorTypes.NETWORK_ERROR:
                                // try to recover network error
                                console.log("HLS: Fatal network error encountered, try to recover");
                                hlsVideo_1.startLoad();
                                break;
                            case Hls.ErrorTypes.MEDIA_ERROR:
                                console.log("HLS: Fatal media error encountered, try to recover");
                                hlsVideo_1.recoverMediaError();
                                break;
                            default:
                                // cannot recover
                                hlsVideo_1.destroy();
                                break;
                        }
                    }
                });
                video.addEventListener('play', function () {
                    hlsVideo_1.startLoad();
                });
            }
            else {
                if (autoplay) {
                    _this.forceAutoPlay(video);
                }
            }
        });
    }
    Video.prototype.forceAutoPlay = function (video) {
        video.volume = 0;
        video.muted = true;
        var playPromise = video.play();
        if (typeof playPromise !== 'undefined') {
            playPromise.catch(function (err) {
                // ignore errors
            });
        }
    };
    return Video;
}());
export { Video };
